import { createSlice } from "@reduxjs/toolkit";

// Define the initial state using that bundle
const initialState: IInventoryBundleState = {
  data: null,
  pageSize: 0,
  pageNumber: 0,
  totalCount: 0,
  showLoading: {
    sourceAction: "",
    state: false,
  },
  isLoading: false,
  isSuccess: false,
  Details: null,
};

export const inventoryBundleSlice = createSlice({
  name: "inventoryBundle",
  // `createSlice` will infer the state bundle from the `initialState` argument
  initialState,
  reducers: {
    setLoading: (state, action) => {
      const { sourceAction, isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: sourceAction,
        state: true,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    resetLoading: (state, action) => {
      state.showLoading = {
        sourceAction: "",
        state: false,
      };
      const { isLoading, isSuccess } = action.payload;
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    replaceInventoryBundle: (state, action) => {
      const { data, pageSize, pageNumber, totalCount } = action.payload;
      state.data = data;
      state.pageSize = pageSize;
      state.pageNumber = pageNumber;
      state.totalCount = totalCount;
    },
    addInventoryBundle: (state, action) => {
      const newItem = action.payload.data;
      if (state.data && state.data.length > state.pageSize) {
        state.data.pop();
      }
      state.data = state.data ? [newItem, ...state.data] : [newItem];
      state.totalCount = state.totalCount + 1;
    },
    updateInventoryBundle: (state, action) => {
      const { localID, data } = action.payload;
      if (localID !== undefined && localID >= 0 && state.data) {
        state.data[localID] = data;
      }
      state.Details = data;
    },
    deleteInventoryBundle: (state, action) => {
      const inventoryBundleToRemove: IInventoryBundle = action.payload.data;
      const newInventoryBundleData =
        state.data &&
        state.data.filter((inventoryBundle: IInventoryBundle) => {
          return inventoryBundle.id !== inventoryBundleToRemove.id;
        });
      state.data = newInventoryBundleData;
      state.totalCount = state.totalCount - 1;
    },
    setInventoryBundleDetails: (state, action) => {
      state.Details = action.payload.data;
    },
  },
});

export const inventoryBundleActions = inventoryBundleSlice.actions;

export default inventoryBundleSlice.reducer;
